export default {
  supportedLngs: ['en', 'km'],
  fallbackLng: 'en',
  defaultNS: 'common',
  react: { useSuspense: false },
};
